export enum LoginAttemptResult {
  SUCCESS = 'SUCCESS',
  MAIL_NOT_FOUND = 'MAIL_NOT_FOUND',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  ACCOUNT_IS_INACTIVE = 'ACCOUNT_IS_INACTIVE',
}
